import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stack,
} from "@mui/material";
import { FaSearch, FaSearchMinus, FaTimes, FaTrash } from "react-icons/fa";
import {
  DataGrid,
  GridActionsCellItem,
  GridColumns,
  GridRowId,
} from "@mui/x-data-grid";
import {
  measureAddNationalMeasure,
  measureListNationalMeasures,
  measureRemoveNationalMeasure,
} from "../../../../../server/server";
import { notif } from "../../../../utils/util";
import ChooseNatRegisterModal from "../../../../modals/ChooseNatRegisterModal";
import ConfirmationModal from "../../../../modals/ConfirmationModal";

interface NationalMeasureRelationModalProps {
  open: boolean;
  onClose: () => void;
  item: any;
}

const NationalMeasureRelationModal: React.FC<
  NationalMeasureRelationModalProps
> = ({ open, onClose, item }) => {
  const [items, setItems] = useState<any>([]);
  const [items1, setItems1] = useState<any>([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selRegister, setSelRegister] = useState<any>(null);
  const [registerType, setRegisterType] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [rowCountState, setRowCountState] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [page1, setPage1] = useState(0);
  const [pageSize1, setPageSize1] = useState(5);
  const [rowCountState1, setRowCountState1] = useState(0);
  const [isLoading1, setIsLoading1] = useState(true);
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
  const [deleteId, setDeleteId] = useState<any>();

  const TYPE_MAP = {
    "Планирани пропис": 0,
    "Постојећи пропис": 1,
  };

  useEffect(() => {
    if (item?.measureId) {
      loadRelations(item.measureId);
    }
  }, [item?.id]);

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const loadRelations = async (pid: any) => {
    setIsLoading(true);
    setIsLoading1(true);
    const resp = await measureListNationalMeasures(pid);

    if (resp?.status === 200) {
      setItems(resp.data?.planned?.items || []);
      setRowCountState(resp?.data?.planned?.total || 0);
      setIsLoading(false);

      setItems1(resp.data?.inForce?.items || []);
      setRowCountState1(resp?.data?.inForce?.total || 0);
      setIsLoading1(false);
    } else {
      setItems([]);
      setItems1([]);
      setRowCountState(0);
      setRowCountState1(0);
      setIsLoading(false);
      setIsLoading1(false);
    }
  };

  const createRelation = async () => {
    if (!selRegister?.id || !item?.id) return;

    const resp = await measureAddNationalMeasure(item.id, selRegister.id);

    if (resp.status === 201) {
      notif("Релација је успешно креирана", "success");
      loadRelations(item.id);
      setPage(0);
      setSelRegister(null);
      setRegisterType("");
    } else {
      notif("Релација није креирана", "error");
    }
  };

  const deleteRelation = async () => {
    const resp = await measureRemoveNationalMeasure(deleteId);

    if (resp.status === 200) {
      notif("Релација је успешно обрисана", "success");
      loadRelations(item.id);
    } else {
      notif("Релација није обрисана", "error");
    }
  };

  const deleteRel = () => {
    deleteRelation();
    setDeleteModalIsOpen(false);
  };

  const closeDeleteModal = () => {
    setDeleteModalIsOpen(false);
  };

  const deleteItem = React.useCallback(
    (id: GridRowId) => () => {
      setTimeout(() => {
        setDeleteModalIsOpen(true);
        setDeleteId(id);
      });
    },
    []
  );

  const setPageAndCall = (page: any) => {
    setPage(page);
    loadRelations(item.id);
  };

  const setPageAndCall1 = (page: any) => {
    setPage1(page);
    loadRelations(item.id);
  };

  const isThere = () => {
    const ids = [...items, ...items1]?.map((itm: any) => itm?.pid);
    return !(selRegister && !ids?.includes(selRegister?.pid));
  };

  const columns = React.useMemo<GridColumns<any>>(
    () => [
      {
        field: "title",
        headerName: "Назив националног прописа",
        flex: 1,
      },
      {
        field: "pid",
        headerName: "Ознака прописа",
        maxWidth: 140,
        minWidth: 140,
        flex: 1,
      },
      {
        field: "username",
        headerName: "Корисник",
        maxWidth: 140,
        minWidth: 140,
        flex: 1,
      },
      // {
      //   field: "actions",
      //   type: "actions",
      //   width: 60,
      //   getActions: (params: any) => [
      //     <GridActionsCellItem
      //       icon={<FaTrash style={{ width: 20, height: 20 }} />}
      //       sx={{ width: 50, height: 50 }}
      //       label="Обриши"
      //       onClick={deleteItem(params.id)}
      //     />,
      //   ],
      // },
    ],
    [deleteItem]
  );

  const handleClose = () => {
    setSelRegister(null);
    setRegisterType("");
    onClose();
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="lg"
        fullWidth
        disableEnforceFocus
      >
        <DialogTitle>
          <div className="flex justify-between items-center">
            <span className="text-[#04438b] text-2xl font-bold">
              Веза са националним прописима - {item?.measureName}
            </span>
            <IconButton onClick={handleClose}>
              <FaTimes />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent>
          <div className="pt-4">
            {/* <div className="flex mt-6 gap-6 justify-between invisible">
              <div className="flex items-center gap-6">
                <FormControl size="small" sx={{ minWidth: 300 }}>
                  <InputLabel id="demo-select-small">Веза са</InputLabel>
                  <Select
                    labelId="demo-select-small"
                    id="demo-select-small"
                    value={registerType || ""}
                    onChange={(e) => setRegisterType(e.target.value)}
                    label="Веза са"
                    fullWidth
                    className="capitalize"
                  >
                    {["Планирани пропис", "Постојећи пропис"]?.map((c) => {
                      return (
                        <MenuItem value={c} className="capitalize" key={c}>
                          {c}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div>

              <div className="flex flex-col">
                <button
                  className={`h-[40px] w-[400px] border-[#81848f3d] border bg-white rounded-md cursor-pointer hover:bg-[#d9d9d9] ${
                    !registerType ? "opacity-60" : ""
                  }`}
                  onClick={() => {
                    if (!registerType) {
                      notif(
                        "Молимо изаберите опцију 'Веза са' пре одабира националног прописа",
                        "warning"
                      );
                      return;
                    }
                    setModalIsOpen(true);
                  }}
                >
                  {selRegister ? (
                    <div className="flex px-4 justify-start text-left items-center">
                      <FaSearchMinus className="fill-[#404040]" />
                      <p className="text-darkBlue w-full pl-3">
                        {selRegister?.title?.length > 35
                          ? selRegister?.title?.substring(0, 35) + "..."
                          : selRegister?.title}
                      </p>
                    </div>
                  ) : (
                    <div className="flex px-4 justify-between items-center">
                      <FaSearch className="fill-[#404040]" />
                      <p className="text-[#404040] w-full pl-3">
                        Одабир Националног прописа
                      </p>
                    </div>
                  )}
                </button>
              </div>
            </div> */}
            {/* 
            <div className="w-full flex justify-end mt-6 items-center invisible">
              <Button
                variant="contained"
                sx={{ backgroundColor: "#0F2765" }}
                onClick={createRelation}
                disabled={isThere()}
              >
                Додај
              </Button>
            </div> */}

            <div>
              {items1?.length > 0 && (
                <div className="mt-5 w-full">
                  <div className="text-[#04438b] mb-2">
                    Повезаност са постојећим националним прописом
                  </div>

                  <DataGrid
                    rowCount={rowCountState1}
                    autoHeight={true}
                    loading={isLoading1}
                    pagination
                    disableColumnMenu
                    paginationMode="server"
                    onPageChange={(newPage) => setPageAndCall1(newPage)}
                    onPageSizeChange={(newPageSize) =>
                      setPageSize1(newPageSize)
                    }
                    page={page1}
                    pageSize={pageSize1}
                    rows={items1}
                    columns={columns}
                    style={{ zIndex: 0 }}
                    rowsPerPageOptions={[5]}
                    disableSelectionOnClick
                    components={{
                      NoRowsOverlay: () => (
                        <Stack
                          height="100%"
                          alignItems="center"
                          justifyContent="center"
                        >
                          Не постоје ставке
                        </Stack>
                      ),
                      NoResultsOverlay: () => (
                        <Stack
                          height="100%"
                          alignItems="center"
                          justifyContent="center"
                        >
                          Не постоје ставке
                        </Stack>
                      ),
                    }}
                  />
                </div>
              )}

              {items?.length > 0 && (
                <div className="mt-5 w-full">
                  <div className="text-[#04438b] mb-2">
                    Повезаност са планираним националним прописом
                  </div>

                  <DataGrid
                    rowCount={rowCountState}
                    autoHeight={true}
                    loading={isLoading}
                    pagination
                    disableColumnMenu
                    paginationMode="server"
                    onPageChange={(newPage) => setPageAndCall(newPage)}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    page={page}
                    pageSize={pageSize}
                    rows={items}
                    columns={columns}
                    style={{ zIndex: 0 }}
                    rowsPerPageOptions={[5]}
                    disableSelectionOnClick
                    components={{
                      NoRowsOverlay: () => (
                        <Stack
                          height="100%"
                          alignItems="center"
                          justifyContent="center"
                        >
                          Не постоје ставке
                        </Stack>
                      ),
                      NoResultsOverlay: () => (
                        <Stack
                          height="100%"
                          alignItems="center"
                          justifyContent="center"
                        >
                          Не постоје ставке
                        </Stack>
                      ),
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        </DialogContent>
      </Dialog>

      <ConfirmationModal
        modalIsOpen={deleteModalIsOpen}
        closeModal={closeDeleteModal}
        confirmation={deleteRel}
        message={`Обриши релацију са домаћим прописом?`}
      />

      <ChooseNatRegisterModal
        modalIsOpen={modalIsOpen}
        closeModal={closeModal}
        setSelRegister={setSelRegister}
        selRegister={selRegister}
        type={TYPE_MAP[registerType as keyof typeof TYPE_MAP]}
        modalTitle={"Одабир домаћег прописа са којим је мера повезана"}
      />
    </>
  );
};

export default NationalMeasureRelationModal;
